export default class SubscriberForm {
    constructor(Rest) {
        this.rest = Rest.rest;
    }

    all() {
        return this.rest.one('subscriber-form').get();
    };

    find(id, include) {
        return this.rest.one('subscriber-form', id).get({ 'includes[]': include });
    };

    create(data) {
        return this.rest.all('subscriber-form').post(data);
    };

    update(id, data) {
        return this.rest.one('subscriber-form', id).customPUT(data);
    };

    delete(subscriberForm) {
        return this.rest.one('subscriber-form', subscriberForm.id).remove();
    };

    getSettings() {
        return this.rest.one('subscriber-form').one('settings').get();
    };

    addSettings(id, settings) {
        return this.rest.all('subscriber-form/' + id + '/settings').post({ settings: settings });
    };

    removeField(subscriberForm, id) {
        return this.rest.one('subscriber-form', subscriberForm.id).one('fields', id).remove();
    };

    saveEmail(id, email) {
        return this.rest.one('subscriber-form', id).one('email').customPUT({ email: email });
    };

    getHistoryMeta(id, emailId) {
        return this.rest.one('subscriber-form', id).one('email').one('history').get();
    };
};
